@let modules = projectModules()?.modules;
<app-overview>
	<app-overview-header>
		<app-overview-header-title>
			<h2 class="mat-body-large">
				{{"Module Aktivieren" | translate : "headline-activate-modules"}}
			</h2>
		</app-overview-header-title>
	</app-overview-header>
	@if(modules && modules.length > 0){
	<app-table>
		<app-table-header-group>
			<app-table-header-row class="mat-body-medium table__header">
				{{"Module und Untermodule" | translate : "label-modules-and-submodules"}}
			</app-table-header-row>
		</app-table-header-group>
		<app-table-data-group>
			<mat-tree #tree [dataSource]="modules" [childrenAccessor]="childrenAccessor">
					<mat-tree-node *matTreeNodeDef="let node" class="table-tree-node" [style.--level]="tree._getLevel(node)">
						<ng-container [ngTemplateOutlet]="nodeContent"
							[ngTemplateOutletContext]="{node: node}" />
				</mat-tree-node>
				<mat-tree-node *matTreeNodeDef="let node;when: hasChild" class="table-tree-node table-tree-node--expandable "
				 [style.--level]="tree._getLevel(node)" [isExpanded]="true">
						<button mat-icon-button matTreeNodeToggle class="tree-node__toggle"
								[attr.aria-label]="'Toggle ' + node.name">
								@if(tree.isExpanded(node)){
										<ogs-m3-icon icon="chevron-down"/>
								}
								@else {
										<ogs-m3-icon icon="chevron-right"/>
								}
						</button>
					 <ng-container [ngTemplateOutlet]="nodeContent"
							[ngTemplateOutletContext]="{node: node}" />
				</mat-tree-node>
		</mat-tree>
	</app-table-data-group>
</app-table>
}
@else{
	<app-table-skeleton/>
}
</app-overview>
<app-form-footer
				(save)="saveChanges()"
				(discard)="discardChanges()"/>

<ng-template #nodeContent let-node="node">
		<section class="table-tree-node__content">
							<mat-checkbox [checked]="node.isChecked" [disabled]="!node.isActive" (change)="changeSelection(node, $event.checked)">
									@let translationInfo = node.translationInfo;
										@if(translationInfo){
											{{translationInfo.defaultText | translate : translationInfo.token : translationInfo.scope}}
										}
							</mat-checkbox>
						</section>
</ng-template>

